import { createContext, useState } from "react"

import { MessageModal, DestructiveConfirmModal } from "../../components/common"

const MessageModalContext = createContext(null)

export const MessageModalContextManager = ({ children }) => {
    const [queue, setQueue] = useState([])

    const modal = queue[0]

    const dequeue = () => {
        setQueue(prev => prev.slice(1))
    }

    const showMessageModal = (props) => {
        setQueue(prev => [...prev, props])
    }

    const renderModal = () => {
        if (!modal) return null

        const dismissHandler = () => {
            modal.onDismiss?.()
            dequeue()
        }
        const confirmHandler = () => {
            modal.onConfirm?.()
            dequeue()
        }

        if (modal.destructive) {
            return (
                <DestructiveConfirmModal
                    key={modal.message}
                    title={modal.title}
                    message={modal.message}
                    confirmPhrase={modal.destructive.confirmPhrase}
                    onDismiss={dismissHandler}
                    onConfirm={confirmHandler}
                />
            )
        }

        return (
            <MessageModal
                title={modal.title}
                message={modal.message}
                onDismiss={dismissHandler}
                onConfirm={confirmHandler}
            />
        )
    }

    return (
        <MessageModalContext.Provider value={{ showMessageModal }}>
            {children}
            {renderModal()}
        </MessageModalContext.Provider>
    )
}

export const MESSAGE_MODALS = {
    BORRAR: {
        title: "Confirmación",
        message: "¿Está seguro/a de borrar el registro?",
    },
    CONFIRM_SALIR: {
        title: 'Confirmación',
        message: 'Hay cambios sin guardar. ¿Desea salir de todas formas?',
    }
}

export default MessageModalContext
